// profile modules
import axios from 'axios';
import { VERIFY_EMAIL_URL, UPDATE_USER_PHOTO, UPLOAD_TAX_FILE } from '../../api/url'
// initial state
const state = {
}

// actions
const actions = {
  verifyEmail: () => axios({ 
    url: VERIFY_EMAIL_URL,  
    method: 'POST',     
    headers: {
      Authorization: `JWT ${localStorage.getItem('token')}`,
    }, 
  }),
  updateUserPhoto: (context, file) => axios({
    url: UPDATE_USER_PHOTO,
    method: 'PUT',
    data: file,
    headers: {
      Authorization: `JWT ${localStorage.getItem('token')}`,      
    }
  }),
  uploadTaxForm: (context, data) => axios({
    url: UPLOAD_TAX_FILE,
    method: 'POST',
    data,
    headers: {
      Authorization: `JWT ${localStorage.getItem('token')}`,      
    }
  }),
};

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/profile.js